var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"7","viewBox":"0 0 11 7","fill":"none"}},[_c('path',{attrs:{"d":"M.83 0h9.32a.83.83 0 01.58 1.43L6.08 6.06a.83.83 0 01-1.18 0L.25 1.42A.83.83 0 01.83 0z","fill":"#5D5D5D"}})])}
var staticRenderFns = []

export { render, staticRenderFns }